import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  constructor(private http: HttpClient) {}

  getAllInventory(search?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = `${SETTINGS.BASE_API}/inventory/get-all`;

      // Add search parameter if provided
      if (search) {
        url += `?search=${encodeURIComponent(search)}`;
      }

      this.http.get(url).subscribe({
        next: (response: any) => resolve(response),
        error: (error: any) => reject(error.error || error),
      });
    });
  }

  getInventoryItem(itemId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/inventory/${itemId}`).subscribe({
        next: (response: any) => resolve(response),
        error: (error: any) => reject(error.error || error),
      });
    });
  }
  createInventoryItem(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/inventory/create`, payload)
        .subscribe({
          next: (response: any) => resolve(response),
          error: (error: any) => reject(error.error || error),
        });
    });
  }
  updateInventoryItem(itemId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/inventory/${itemId}`, payload)
        .subscribe({
          next: (response: any) => resolve(response),
          error: (error: any) => reject(error.error || error),
        });
    });
  }

  deleteInventoryItem(itemId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.delete(`${SETTINGS.BASE_API}/inventory/${itemId}`).subscribe({
        next: (response: any) => resolve(response),
        error: (error: any) => reject(error.error || error),
      });
    });
  }
  getPagedInventory(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/inventory/get-paged`, payload)
        .subscribe({
          next: (response: any) => resolve(response),
          error: (error: any) => reject(error.error || error),
        });
    });
  }

  softDeleteInventoryItem(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/inventory/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => resolve(response),
          error: (error: any) => reject(error.error || error),
        });
    });
  }
}
